<template>
  <div class="grid">
    <div class="col-12">
      <Card>
        <template #title>Удаление КИ</template>
        <template #content>
          <TabView>
            <TabPanel header="Удаление">
              <div class="p-fluid" style="max-width: 600px;">
                  <label class="font-bold">Выберите способ удаления</label>
                  <Dropdown
                      v-model="selectedGroup"
                      :options="groupOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Выберите способ удаления"
                  />

                <!-- События по выбранной группе -->
                <div v-if="selectedGroupEvents.length" class="field">
                  <label class="font-bold">События группы {{ selectedGroup }}</label>
                  <div class="flex flex-column gap-2">
                    <div
                        v-for="event in selectedGroupEvents"
                        :key="event.value"
                        class="event-option"
                    >
                      <Checkbox
                          :inputId="event.value"
                          v-model="form.selectedEvents"
                          :value="event.value"
                          :disabled="isEventDisabled(event)"
                          @change="() => onEventChange(event.value)"
                      />
                      <label :for="event.value" class="ml-2">{{ event.label }}</label>
                    </div>
                  </div>
                </div>

                <!-- Dropdown: основание -->
                <div class="field">
                  <label class="font-bold">Основание</label>
                  <Dropdown
                      v-model="form.reason"
                      :options="reasons.filter(r => r.group === selectedGroup)"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Выберите основание"
                      :disabled="form.selectedEvents.length === 0"
                  />
                </div>

                <p v-if="form.reason" class="text-sm text-gray-700">
                  {{
                    reasons.find(r => r.value === form.reason && r.group === selectedGroup)?.description || ''
                  }}
                </p>

                <div class="field">
                  <label class="font-bold">Выберите бюро</label>
                  <div class="flex flex-column gap-2">
                    <div v-for="bureau in bureaus" :key="bureau.value" class="bureau-option">
                      <Checkbox
                          :inputId="`bureau-${bureau.value}`"
                          v-model="form.selectedBureaus"
                          :value="bureau.value"
                      />
                      <label :for="`bureau-${bureau.value}`" class="ml-2">{{ bureau.label }}</label>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <Checkbox inputId="sendStop" v-model="form.sendStop" :binary="true" />
                  <label for="sendStop" class="font-bold ml-2">Добавлять в стоп-лист</label>
                </div>

                <div class="field">
                  <label class="font-bold">Список займов</label>
                  <Chips
                      ref="chips"
                      v-model="form.loanList"
                      placeholder="Введите UUID, ЦБ УИД или номера через пробел"
                      class="w-full"
                      @paste="handlePaste"
                  />
                </div>

                <Button label="Отправить" @click="submit" class="mt-3" />
              </div>
            </TabPanel>
            <TabPanel>
              <template #header>
                <span>Отчёты на удаление КИ</span>
              </template>
              <DeleteReportsTable />
            </TabPanel>
            <TabPanel>
              <template #header>
                <span>Список займов с удаленной КИ</span>
              </template>
              <DeleteEventsTable />
            </TabPanel>
          </TabView>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import Card from 'primevue/card'
import Chips from 'primevue/chips'
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import Button from 'primevue/button'
import FunctionsService from "@/service/FunctionsService";
import ResponseService from "@/service/ResponseService";
import EventService from "@/service/EventService";
import DeleteReportsTable from "@/components/tables/DeleteReportsTable.vue";
import DeleteEventsTable from "@/components/tables/DeleteEventsTable.vue";

export default {
  name: 'DeleteDataFormCard',
  components: {
    Card,
    Dropdown,
    Checkbox,
    Button,
    Chips,
    DeleteReportsTable,
    DeleteEventsTable
  },
  data() {
    return {
      selectedGroup: '',
      form: {
        selectedEvents: [],
        loanList: [],
        selectedBureaus: [],
        reasons: '',
        sendStop: true
      },
      groupOptions: [
        { label: 'События группы 3X', value: '3X' },
        { label: 'События группы 4X', value: '4X' }
      ],
      eventGroups: {
        '3X': [
          { label: '3.3 Удаление Основной части (Договор)', value: '3.3', isDisabled: false, requires: ['3.4'] },
          { label: '3.4 Удаление Информационной части (Заявка)', value: '3.4', isDisabled: false},
          { label: '3.5 Удаление всех частей (Удаление всей КИ)', value: '3.5', isDisabled: false, isUniq: true }
        ],
        '4X': [
          { label: '4.4 Удаление Информационной части на законных основаниях (Заявка)', value: '4.4', isDisabled: false },
          { label: '4.2 Удаление Основной части на законных основаниях (Договор)', value: '4.2', isDisabled: false, requires: ['4.4']  },
          { label: '4.3 Удаление всех частей на законных основаниях (Удаление всей КИ)', value: '4.3', isDisabled: false, isUniq: true }
        ]
      },
      reasons: [
        {
          label: 'Удаление по суду (D.1)',
          value: 'D.1',
          group: '4X',
          description: 'Aннулируется запись и (или) иные данные кредитной истории на основании решения суда, вступившего в силу'
        },
        {
          label: 'Мошенничество (D.2)',
          value: 'D.2',
          group: '4X',
          description: 'Aннулируется запись и (или) иные данные кредитной истории по результатам рассмотрения указанного в части 3 статьи 8 Федерального закона «О кредитных историях» (Собрание законодательства Российской Федерации, 2005, № 1, ст. 44; 2020, № 31, ст. 5061) заявления субъекта в случае, если по результатам рассмотрения такого заявления принято решение о полном оспаривании информации, содержащейся в его кредитной истории'
        },
        {
          label: 'Удаление "Правительственные меры" (D.4)',
          value: 'D.4',
          group: '4X',
          description: 'Aннулируется запись и (или) иные данные кредитной истории на основании обращения источника в случаях, установленных частью 7 статьи 5 Федерального закона «О кредитных историях» (Собрание законодательства Российской Федерации, 2005, №1, ст.44; 2018, №1, ст.65; 2020, № 31, ст.5061)'
        },
        {
          label: 'Удаление по собственным причинам компании (C.2)',
          value: 'C.2',
          group: '3X',
          description: ''
        }
      ],
      bureaus: [
        { label: 'НБКИ', value: 'nbki' },
        { label: 'Эквифакс', value: 'equ' },
      ],
    }
  },
  computed: {
    selectedGroupEvents() {
      return this.selectedGroup ? this.eventGroups[this.selectedGroup] : []
    }
  },
  methods: {
    onEventChange(changedValue) {
      const uniqEvent = this.selectedGroupEvents.find(e => e.isUniq)
      const isUniq = uniqEvent && uniqEvent.value === changedValue
      const isUniqSelected = this.form.selectedEvents.includes(uniqEvent?.value)
      const changedEvent = this.selectedGroupEvents.find(e => e.value === changedValue)
      const isAlreadySelected = this.form.selectedEvents.includes(changedValue)

      if (isUniq) {
        if (!isAlreadySelected) {
          this.form.selectedEvents = []
        } else {
          this.form.selectedEvents = [uniqEvent.value]
        }
        return
      }

      if (!isAlreadySelected) {
        // Пользователь снимает чекбокс — удаляем связанные, которые зависят от него
        const dependents = this.selectedGroupEvents.filter(e =>
            e.requires?.includes(changedValue)
        ).map(e => e.value)

        this.form.selectedEvents = this.form.selectedEvents.filter(e => e !== changedValue && !dependents.includes(e))
      } else {
        // Пользователь ставит чекбокс — добавляем зависимости
        if (isUniqSelected) {
          this.form.selectedEvents = this.form.selectedEvents.filter(e => e !== uniqEvent.value)
        }

        if (changedEvent?.requires?.length) {
          changedEvent.requires.forEach(reqValue => {
            if (!this.form.selectedEvents.includes(reqValue)) {
              this.form.selectedEvents.push(reqValue)
            }
          })
        }
      }
    },
    isEventDisabled(event) {
      return !!event.isDisabled
    },
    isValidUuid(uuid) {
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return uuidRegex.test(uuid);
    },
    isValidCbUuid(cbUuid) {
      const cbUuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-[0-9a-f]$/i;
      return cbUuidRegex.test(cbUuid);
    },
    normalizeLoanListItem(item) {
      const trimmed = item.trim();
      if (this.isValidUuid(trimmed) || this.isValidCbUuid(trimmed)) {
        return trimmed;
      }

      // Если это число — возвращаем как строку
      if (/^\d+$/.test(trimmed)) {
        return trimmed;
      }

      return null;
    },
    submit() {
      if (!this.form.selectedBureaus.length) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Выберите хотя бы одно бюро',
          detail: 'Необходимо указать бюро',
          life: 3000
        });
        return;
      }

      const normalizedLoanList = this.form.loanList
          .map(this.normalizeLoanListItem)
          .filter(item => item !== null);

      if (!normalizedLoanList.length || !this.form.reason) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Проверьте данные',
          detail: 'Нужно выбрать основание и ввести хотя бы один UUID, ЦБ УИД или номер займа',
          life: 3000
        });
        return;
      }

      const invalidItems = this.form.loanList.filter(item => this.normalizeLoanListItem(item) === null);
      if (invalidItems.length > 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Некорректные значения',
          detail: `Невалидные идентификаторы: ${invalidItems.join(', ')}`,
          life: 4000
        });
        return;
      }

      const payload = {
        applicationUuid: normalizedLoanList,
        code: this.form.reason,
        actions: this.form.selectedEvents,
        bureaus: this.form.selectedBureaus
      };

      this.$toast.add({
        severity: 'info',
        summary: 'Обработка...',
        detail: 'Отправка запроса на удаление',
        life: 2000
      });

      FunctionsService.deleteEvent(
          payload.applicationUuid,
          payload.code,
          payload.actions,
          payload.bureaus,
          this.form.sendStop
      )
          .then((res) => {
            this.$toast.add({
              severity: 'success',
              summary: 'Запрос на удаление принят',
              detail: res.feedback || 'Результат будет доступен в отчётах на удаление',
              life: 6000
            });
            this.form.loanList = [];
            this.form.reason = '';
            this.form.selectedEvents = [];
            this.selectedGroup = '';
          })
          .catch((err) => {
            const eventId = ResponseService.getConvertEventId(err);
            if (eventId !== null) {
              this.promptConvertEvent(eventId, err);
              return;
            }
            ResponseService.handleErrorResponseWithoutForm(err, this.$toast);
          });
    },
    promptConvertEvent(eventId, err) {
      const reason = typeof err?.data === 'string'
          ? err.data
          : (typeof err?.message === 'string' ? err.message : '');

      this.$confirm.require({
        header: 'Требуется преобразование события',
        message: `${reason}\n\nПреобразовать событие №${eventId} в актуальный формат и повторить удаление?`,
        acceptIcon: 'pi pi-check',
        acceptLabel: 'Преобразовать',
        rejectLabel: 'Отмена',
        accept: () => {
          this.$toast.add({
            severity: 'info',
            summary: 'Преобразование...',
            detail: `Подготовка события №${eventId} к актуальному формату`,
            life: 2000
          });

          EventService.convertToNewFormat(eventId)
              .then((res) => {
                if (res.error === true) {
                  this.$toast.add({
                    severity: 'error',
                    summary: 'Ошибка',
                    detail: res.feedback || `Не удалось преобразовать событие №${eventId}`,
                    life: 5000
                  });
                  return;
                }

                this.$toast.add({
                  severity: 'success',
                  summary: 'Событие преобразовано',
                  detail: res.feedback || `Событие №${eventId} подготовлено. Повторяем удаление...`,
                  life: 3000
                });

                this.submit();
              })
              .catch((convertErr) => {
                ResponseService.handleErrorResponseWithoutForm(convertErr, this.$toast);
              });
        }
      });
    },
    handleKeydown(e) {
      if (e.key === ' ') {
        const input = e.target
        const value = input.value.trim()
        if (value.length > 0) {
          this.form.loanList.push(value)
          input.value = ''
          e.preventDefault()
        }
      }
    },
    handlePaste(e) {
      const pasted = e.clipboardData.getData('text')
      const parts = pasted.split(/\s+/).filter(p => p.length > 0)
      this.form.loanList.push(...parts)
      e.preventDefault()
    },
  },
  watch: {
    selectedGroup() {
      this.form.selectedEvents = []
      this.form.reason = ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      const chipsInput = this.$refs.chips.$el.querySelector('input')
      chipsInput?.addEventListener('keydown', this.handleKeydown)
    })
  }
}
</script>

<style scoped>
.field {
  margin-bottom: 1rem;
}
</style>